import { computed, Ref } from 'vue';
import { useStore } from 'vuex';
import constants from '@/utilities/constants';
import { Card } from '@superthread-com/api';

export default function useAddOrRemoveFromEpic(card: Ref<Card>) {
  const store = useStore();

  const addedToEpic = computed((): boolean => {
    return Object.keys(card?.value?.epic ?? {}).length > 0;
  });

  const setAddToEpicSearchResults = async () => {
    await store.dispatch('fetchBoard', { boardId: constants.epicsBoardId });
    const epics = Object.values(store.getters.getEpics);
    store.dispatch('setSearchResults', {
      count: epics.length,
      cursor: '',
      epics,
    });
    store.dispatch('setCurrentCardIdForActionEdit', card?.value?.id ?? 'quick-card');
  };

  const showAddToEpicPopup = async (viewType: string = '') => {
    if (addedToEpic.value) return;
    setAddToEpicSearchResults();
    const openedInDocked =
      store.getters.getLayoutOfDisplayedCard(card.value.id) === constants.docked;
    const modalViewType = openedInDocked ? constants.cardView : constants.boardView;
    store.dispatch('setShowSetParentCardPopup', `addEpicToCard-${viewType || modalViewType}`);
  };

  const removeCardFromEpic = () => {
    store.dispatch('removeCardFromEpic', card.value.id);
  };

  return {
    addedToEpic,
    showAddToEpicPopup,
    removeCardFromEpic,
    setAddToEpicSearchResults,
  };
}
